// extracted by mini-css-extract-plugin
export default {"supreme":"Benefits_supreme__fMToZ","parent":"Benefits_parent__VJhG1","one":"Benefits_one__LMs6R","floatUpDown":"Benefits_floatUpDown__h2srO","two":"Benefits_two__FXOQ2"};